import React from 'react';
import skill1ImageSrc from '../../assets/images/result/skill-1.png';
import skill2ImageSrc from '../../assets/images/result/skill-12.png';
import skill3ImageSrc from '../../assets/images/result/skill-3.png';
import skill4ImageSrc from '../../assets/images/result/skill-13.png';
import skill6ImageSrc from '../../assets/images/result/skill-14.png';
import skill7ImageSrc from '../../assets/images/result/skill-7.png';
import styles from './SkillList.css';

const SKILL_LIST = [
    {
        id: 1,
        name: 'Peace of mind',
        description: 'Feel secure knowing you, your family, and your finances are protected from unforeseen risks.',
        imageUrl: skill3ImageSrc
    },
    {
        id: 2,
        name: 'Confidence',
        description: '99% malicious malware in browser blocked.',
        imageUrl: skill4ImageSrc
    },
    {
        id: 3,
        name: 'Empowerment',
        description: 'Futureproof users report 74% scams more then average users and fall victim to 79% scams less.',
        imageUrl: skill2ImageSrc
    },
    {
        id: 4,
        name: 'Relief',
        description: 'Avoid the stress of navigating complex insurance plans or dealing with unexpected emergencies unprepared.',
        imageUrl: skill7ImageSrc
    },
    {
        id: 5,
        name: 'Trust',
        description: 'Rely on a solution that works for your safety and well-being, backed by cutting-edge AI.',
        imageUrl: skill6ImageSrc
    },
    {
        id: 6,
        name: 'Hope for the Future',
        description: 'Embrace a sense of security knowing you’re proactively building a safer and better tomorrow.',
        imageUrl: skill1ImageSrc
    }
];

function SkillList({list = SKILL_LIST, className}) {
    return (
        <ul className={`${styles.root} ${className}`}>
            {list.map(item => (
                <li key={item.id} className={styles.item}>
                    <div className={styles.wrapper}>
                        <img
                            className={styles.image}
                            alt={item.name}
                            src={item.imageUrl}
                        />
                        <div>
                            <p className={styles.name}>{item.name}</p>
                            <p className={styles.description}>{item.description}</p>
                        </div>   
                    </div>
                </li>
            ))}
        </ul>
    )
};

export {
    SkillList
};
